<!-- Hero Section -->
<!-- <div class="hero-section">
    <div class="hero-overlay"></div>
    <div class="hero-content">
        <h1 class="hero-title">Empowering Classrooms Across India</h1>
        <p class="hero-subtitle">
            Learn more about our mission, leadership, culture, and join our team transforming education through
            technology.
        </p>
    </div>
</div> -->

<!-- About Us Section -->
<div class="position-relative w-100 overflow-hidden">
    <div class="d-block d-md-none text-center header-spacer"></div>

    <div class="hero-container">
        <!-- Placeholder Hero Image -->
        <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/KiNiJF04tLsKIFI88YFtKPmQInvIE3g1lB345f7K.jpg"
            alt="Contact Us Hero" class="img-fluid w-100 hero-image d-block" />

        <div class="hero-overlay-content">
            <h1 class="mb-3 fw-semibold">ABOUT VIRSA</h1>
            <p class="lead">
                Virsa is a leading EdTech solutions provider delivering Interactive Flat Panels, IFP
                Protection (Shutter), All-in-One PCs, LMS, K–12 Content, Digital E-Library, and Interactive
                Classroom solutions.<br> We help schools, colleges, and education institutions upgrade to smart,
                future-ready learning environments.
            </p>
        </div>
    </div>
</div>

<!-- Leadership Section -->
<section class="section leadership-section">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title"><span>Leadership</span></h2>
            <div class="title-underline"></div>
            <p class="section-description">
                Leadership team brings deep expertise in education, technology, and large-scale digital
                deployments—ensuring innovation, reliability, and customer success.
        </div>
    </div>
</section>

<!-- Vision & Mission Section -->
<section class="section vision-mission-section" id="vision-mission">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">Vision & <span>Mission</span></h2>
            <div class="title-underline"></div>
        </div>
        <div class="grid-layout vision-mission-grid">
            <div class="vm-card">
                <div class="icon-wrapper">
                    <mat-icon>flag</mat-icon>
                </div>
                <h3 class="vm-title">Mission</h3>
                <p class="vm-text">
                    To make all schools in India smart schools through meaningful digital learning solutions.
                </p>
            </div>
            <div class="vm-card">
                <div class="icon-wrapper">
                    <mat-icon>visibility</mat-icon>
                </div>
                <h3 class="vm-title">Vision</h3>
                <p class="vm-text">
                    To provide affordable, reliable, and culturally rooted digital learning solutions for institutions
                    across India.
                </p>
            </div>

        </div>
    </div>
</section>
<!-- Manufacturing Section -->
<section class="section manufacturing-section">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">State-of-the-Art <span>Manufacturing Unit</span></h2>
            <div class="title-underline"></div>
            <p class="section-description">
                Our manufacturing facility is equipped with cutting-edge technology and automated precision engineering.
                We ensure the highest quality standards with rigorous testing and quality control processes at every
                stage
                of production.
            </p>
        </div>
        <div class="grid-layout manufacturing-grid">
            <div class="manufacturing-card">
                <img #img1 src="assets/images/smartroom/1.jpg" alt="Manufacturing Unit 1"
                    (click)="openImageModal(img1.src)">
            </div>
            <div class="manufacturing-card">
                <img #img2 src="assets/images/smartroom/2.jpg" alt="Manufacturing Unit 2"
                    (click)="openImageModal(img2.src)">
            </div>
            <div class="manufacturing-card">
                <img #img3 src="assets/images/smartroom/3.jpg" alt="Manufacturing Unit 3"
                    (click)="openImageModal(img3.src)">
            </div>
            <div class="manufacturing-card">
                <img #img4 src="assets/images/smartroom/4.jpg" alt="Manufacturing Unit 4"
                    (click)="openImageModal(img4.src)">
            </div>
            <div class="manufacturing-card">
                <img #img5 src="assets/images/smartroom/5.jpg" alt="Manufacturing Unit 5"
                    (click)="openImageModal(img5.src)">
            </div>
            <div class="manufacturing-card">
                <img #img6 src="assets/images/smartroom/6.jpg" alt="Manufacturing Unit 6"
                    (click)="openImageModal(img6.src)">
            </div>
            <div class="manufacturing-card">
                <img #img7 src="assets/images/smartroom/7.jpg" alt="Manufacturing Unit 7"
                    (click)="openImageModal(img7.src)">
            </div>
            <div class="manufacturing-card">
                <img #img8 src="assets/images/smartroom/8.jpg" alt="Manufacturing Unit 8"
                    (click)="openImageModal(img8.src)">
            </div>
            <div class="manufacturing-card">
                <img #img9 src="assets/images/smartroom/9.jpg" alt="Manufacturing Unit 9"
                    (click)="openImageModal(img9.src)">
            </div>
            <div class="manufacturing-card">
                <img #img10 src="assets/images/smartroom/10.jpg" alt="Manufacturing Unit 10"
                    (click)="openImageModal(img10.src)">
            </div>
            <div class="manufacturing-card">
                <img #img11 src="assets/images/smartroom/11.jpg" alt="Manufacturing Unit 11"
                    (click)="openImageModal(img11.src)">
            </div>
        </div>

        <!-- Image Modal -->
        <div class="image-modal" *ngIf="selectedImage">
            <div class="modal-backdrop" (click)="closeImageModal()"></div>
            <div class="modal-content">
                <button class="close-btn" (click)="closeImageModal()">
                    <mat-icon>close</mat-icon>
                </button>
                <img [src]="selectedImage" alt="Full size image">
            </div>
        </div>
    </div>
</section>


<!-- Culture Section -->
<section class="section culture-section">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">Team <span>Work</span></h2>
            <div class="title-underline"></div>
            <p class="section-description">
                We believe in innovation, transparency, teamwork, and continuous learning. Our culture encourages bold
                ideas, quality work, and customer-first thinking.
            </p>
        </div>
        <div class="grid-layout culture-grid">
            <div class="culture-card" *ngFor="let value of cultureValues">
                <div class="icon-wrapper">
                    <mat-icon>{{ value.icon }}</mat-icon>
                </div>
                <h3 class="culture-title">{{ value.title }}</h3>
                <p class="culture-description">{{ value.description }}</p>
            </div>
        </div>
    </div>
</section>

<!-- Careers Section -->
<section class="section careers-section">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">Join Our <span>Team</span></h2>
            <div class="title-underline"></div>
            <p class="section-description">
                Join a fast-growing EdTech company transforming classrooms across India. We offer growth opportunities,
                mentorship, continuous learning, and an inclusive workspace.
            </p>
        </div>

        <div class="application-form-wrapper">
            <h3 class="form-title">Apply Now</h3>
            <form [formGroup]="applicationForm" (ngSubmit)="onSubmit()" class="application-form">
                <div class="form-row">
                    <div class="form-group">
                        <label for="name">Full Name *</label>
                        <input type="text" id="name" formControlName="name" placeholder="Enter your full name"
                            class="form-control">
                        <span class="error-message"
                            *ngIf="applicationForm.get('name')?.invalid && applicationForm.get('name')?.touched">
                            Please enter a valid name (min 3 characters)
                        </span>
                    </div>

                    <div class="form-group">
                        <label for="email">Email *</label>
                        <input type="email" id="email" formControlName="email" placeholder="your.email@example.com"
                            class="form-control">
                        <span class="error-message"
                            *ngIf="applicationForm.get('email')?.invalid && applicationForm.get('email')?.touched">
                            Please enter a valid email address
                        </span>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="phone">Phone Number *</label>
                        <input type="tel" id="phone" formControlName="phone" placeholder="10-digit mobile number"
                            class="form-control">
                        <span class="error-message"
                            *ngIf="applicationForm.get('phone')?.invalid && applicationForm.get('phone')?.touched">
                            Please enter a valid 10-digit phone number
                        </span>
                    </div>

                    <div class="form-group">
                        <label for="role">Position Applied For *</label>
                        <select id="role" formControlName="role" class="form-control">
                            <option value="">Select a role</option>
                            <option value="software-engineer">Software Engineer</option>
                            <option value="sales-executive">Sales Executive</option>
                            <option value="content-developer">Content Developer</option>
                            <option value="technical-support">Technical Support</option>
                            <option value="hr-manager">HR Manager</option>
                            <option value="other">Other</option>
                        </select>
                        <span class="error-message"
                            *ngIf="applicationForm.get('role')?.invalid && applicationForm.get('role')?.touched">
                            Please select a role
                        </span>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label for="resume">Upload Resume *</label>
                    <div class="file-upload-wrapper">
                        <input type="file" id="resume" (change)="onFileSelected($event)" accept=".pdf,.doc,.docx"
                            class="file-input">
                        <label for="resume" class="file-label">
                            <mat-icon>upload_file</mat-icon>
                            <span>{{ selectedFile ? selectedFile.name : 'Choose PDF or DOC file' }}</span>
                        </label>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label for="message">Cover Letter / Message *</label>
                    <textarea id="message" formControlName="message"
                        placeholder="Tell us why you'd be a great fit for Virsa..." rows="5"
                        class="form-control"></textarea>
                    <span class="error-message"
                        *ngIf="applicationForm.get('message')?.invalid && applicationForm.get('message')?.touched">
                        Please enter a message (min 10 characters)
                    </span>
                </div>

                <button type="submit" class="btn-submit" [disabled]="!applicationForm.valid || !selectedFile">
                    <mat-icon>send</mat-icon>
                    Submit Application
                </button>
            </form>
        </div>
    </div>
</section>

<!-- Image Modal -->
<div class="image-modal" *ngIf="selectedImage">
    <div class="modal-backdrop" (click)="closeImageModal()"></div>
    <div class="custom-modal-content">
        <button class="close-btn" (click)="closeImageModal()">
            <mat-icon>close</mat-icon>
        </button>
        <img [src]="selectedImage" alt="Full size image">
    </div>
</div>